import Image from 'next/image';
import React from 'react';
import DarkCard from '@/components/cards/DarkCard';
import TypingEffect from './FooterCTA';

export const AboutContent = () => {
  return (
    <div className="mb-16 md:mb-36">
      <div className="flex flex-col items-center gap-y-8">
        <DarkCard
          imgDesktop={
            <Image
              src={'/img/forHoldersDesktop.png'}
              width={500 / 1.5}
              height={340 / 1.5}
              objectFit="contain"
              alt="For Holders Image"
            />
          }
          imgMobile={
            <Image
              src={'/img/ForHoldersMobile.png'}
              width={500 / 1.5}
              height={500 / 1.5}
              alt="For Holders Image"
            />
          }
          pillTitle={'For holders'}
          titleOne={'Make your NFTs'}
          titleTwo={'Influential.'}
          content={
            'Unlock the full potential of your NFT with brand licensing. Elevate the recognition and impact of your NFT by capitalizing on its inherent value and granting licenses to renowned brands for product or media incorporation.'
          }
          features={[
            'Accrue influence and recognition with your NFT',
            'Partner with brands you love',
            'Quick, clear, and simple guided Web3 licensing processes',
          ]}
        />
        <DarkCard
          imgDesktop={
            <Image
              src={'/img/collections.png'}
              width={800 / 1.5}
              height={344 / 1.5}
              objectFit="contain"
              alt="Collections Image"
            />
          }
          imgMobile={
            <Image
              src={'/img/collectionsMobile.png'}
              width={685 / 1.5}
              height={277 / 1.5}
              alt="Collections Image"
              className="rounded-[16px]"
            />
          }
          reverseOrder={false}
          pillTitle={'Collections'}
          titleOne={'Build Awareness'}
          titleTwo={'For Your Collection'}
          content={
            // eslint-disable-next-line quotes
            "Supercharge your NFT collection's global visibility beyond the realm of Web3 through licensing. Each licensed NFT acts as a powerful catalyst, amplifying the reach and unlocking unparalleled growth for your collection."
          }
          features={[
            'Licensed NFTs build awareness and visibility for your community',
            'Grow your audience worldwide',
            'Increase collection and holder value through IP monetization',
            'Increase holder utility without airdrops',
          ]}
        />
        <DarkCard
          imgDesktop={
            <Image
              src={'/img/forBrandsDesktop.png'}
              width={849 / 1.5}
              height={466 / 1.5}
              objectFit="contain"
              alt="for Brands image"
            />
          }
          imgMobile={
            <Image
              src={'/img/forBrandsMobile.png'}
              width={600 / 1.5}
              height={510 / 1.5}
              alt="for Brands image"
              className="rounded-[16px]"
            />
          }
          pillTitle={'For Brands'}
          titleOne={'Mutually Beneficial'}
          titleTwo={'Licensing Partnerships'}
          content={
            'Discover a seamless and efficient path to partnering with Web3 collections and acquiring the ideal intellectual property (IP) that perfectly aligns with your campaigns, all at a reasonable price.'
          }
          features={[
            'Find the best digital assets and Web3 communities that align with the needs of your campaign',
            'Be a part of the Web3 digital ecosystem',
            'Get valuable IP for reasonable prices',
          ]}
        />{' '}
      </div>

      <div className="pt-16 md:pt-20">
        <TypingEffect />
      </div>
    </div>
  );
};
